import { Injectable } from '@angular/core';

interface MenuItem {
    title: string;
    type: string;
    badge?: {
        class: string;
        text: string;
    };
    link?: string;
    active?: boolean;
    icon?: string;
    submenus?: MenuItem[];
}

@Injectable({
    providedIn: 'root'
})
export class SidebarMenuService {

  menus: MenuItem[]
  system: string;

    constructor() {
      this.menus =[]
      this.system=localStorage.getItem('system');
      if(this.system == 'TRAVEL'){
        this.menus =[
        {
          "title": "Dashboard",
          "type": "simple",
          "icon": "<i class=\"fas fa-tachometer-alt\"></i>",
          "link": "/travels-dashboard"
        },
          {
            "title": "Packages",
            "type": "dropdown",
            "icon": "<i class=\"fas fa-list-alt\"></i>",
            "submenus": [
              {
                "title": "Create package",
                "type": "simple",
                "link": "/create-package",
              },
              {
                "title": "Packages manage",
                "type": "simple",
                "link": "/packages",
              },
              {
                "title": "Itenary manage",
                "type": "simple",
                "link": "/itenary-manage",
              },
              {
                "title": "Category manage",
                "type": "simple",
                "link": "/category",
              },

            ]

          },
          {
            "title": "Ticketing",
            "type": "simple",

            "icon": "<i class=\"fas fa-plane-departure\"></i>",
            "link": "/ticketing"
          },
          {
            "title": "Bookings",
            "type": "dropdown",
            "icon": "<i class=\"fas fa-calendar-check\"></i>",
            "submenus": [
              {
                "title": "Package Bookings",
                "type": "simple",
                "link": "/bookings"
              },
              {
                "title": "Ticket Bookings",
                "type": "simple",
                "link": "/accepted-bookings",
              },]
          },
          {
            "title": "Transport",
            "type": "simple",
            "icon": "<i class=\"fas fa-truck-pickup\"></i>",
            "link": "/transport"
          },
          {
            "title": "Reviews",
            "type": "simple",
            "icon": "<i class=\"far fa-star\"></i>",
            "link": "/reviews",
          },
          {
            "title": "Galary",
            "type": "simple",
            "icon": "<i class=\"far fa-images\"></i>",
            "link": "/galary"
          },
          {
            "title": "Settings",
            "type": "dropdown",
            "icon": "<i class=\"fas fa-cog\"></i>",
            "submenus": [
              {
                "title": "User Manage",
                "type": "simple",
                "link": "/new-user"
              },
              {
                "title": "Password Change",
                "type": "simple",
                "link": "/password"
              },
              {
                "title": "Profile",
                "type": "simple",
                "icon": "<fa-icon [icon]=\"['fab', 'github']\"></fa-icon>",
                "link": "/user-profile"
              },
            ]
          },
        ]
      }else if(this.system =='RESORT'){
        this.menus = [
          {
            "title": "Dashboard",
            "type": "simple",
            "icon": "<i class=\"fas fa-tachometer-alt\"></i>",
            "link": "/travels-dashboard"
          },
          {
            "title": "Packages",
            "type": "dropdown",
            "icon": "<i class=\"fas fa-list-alt\"></i>",
            "submenus": [
              {
                "title": "Create package",
                "type": "simple",
                "link": "/resort-package-create",
              },
              {
                "title": "packages manage",
                "type": "simple",
                "link": "/resort-package-manage",
              },

            ]

          },
          {
            "title": "Bookings",
            "type": "simple",
            "icon": "<i class=\"fas fa-calendar-check\"></i>",
            "link": "/resort-booking"
          },
          {
            "title": "Reviews",
            "type": "simple",
            "icon": "<i class=\"far fa-star\"></i>",
            "link": "/reviews",
          },
          {
            "title": "Galary",
            "type": "simple",
            "icon": "<i class=\"far fa-images\"></i>",
            "link": "/galary"
          },
          {
            "title": "Settings",
            "type": "dropdown",
            "icon": "<i class=\"fas fa-cog\"></i>",
            "submenus": [
              {
                "title": "User Manage",
                "type": "simple",
                "link": "/new-user"
              },
              {
                "title": "Password Change",
                "type": "simple",
                "link": "/password"
              },
              {
                "title": "Profile",
                "type": "simple",
                "icon": "<fa-icon [icon]=\"['fab', 'github']\"></fa-icon>",
                "link": "/user-profile"
              },
            ]
          },
        ]

      }else if(this.system =='INTERNATIONAL'){
        this.menus = [
          {
            "title": "Dashboard",
            "type": "simple",
            "icon": "<i class=\"fas fa-tachometer-alt\"></i>",
            "link": "/travels-dashboard"
          },
          {
            "title": " Destinations",
            "type": "simple",
            "icon": "<i class=\"fas fa-globe-americas\"></i>",
            "link": "/destination"

          },
          {
            "title": "Courses",
            "type": "simple",
            "icon": "<i class=\"fas fa-book\"></i>",
            "link": "/courses"
          },
          {
            "title": "University",
            "type": "simple",
            "icon": "<i class=\"fas fa-university\"></i>",
            "link": "/university"
          },
          {
            "title": "Notice",
            "type": "simple",
            "icon": "<i class=\"fas fa-newspaper\"></i>",
            "link": "/news"
          },
          {
            "title": "Reviews",
            "type": "simple",
            "icon": "<i class=\"far fa-star\"></i>",
            "link":"/reviews"
          },
          {
            "title": "Settings",
            "type": "dropdown",
            "icon": "<i class=\"fas fa-cog\"></i>",
            "submenus": [
              {
                "title": "User Manage",
                "type": "simple",
                "link": "/new-user"
              },
              {
                "title": "Password Change",
                "type": "simple",
                "link": "/password"
              },
              {
                "title": "Profile",
                "type": "simple",
                "icon": "<fa-icon [icon]=\"['fab', 'github']\"></fa-icon>",
                "link": "/user-profile"
              },
            ]
          },
        ]

      }
    }

    getMenuList() {
        return this.menus;
    }

    getMenuItemByUrl(aMenus: MenuItem[], aUrl: string): MenuItem {
        for (const theMenu of aMenus) {
            if (theMenu.link && theMenu.link === aUrl) {
                return theMenu;
            }

            if (theMenu.submenus && theMenu.submenus.length > 0) {
                const foundItem = this.getMenuItemByUrl(theMenu.submenus, aUrl);
                if (foundItem) {
                    return foundItem;
                }
            }
        }

        return undefined;
    }

    toggleMenuItem(aMenus: MenuItem[], aCurrentMenu: MenuItem): MenuItem[] {
        return aMenus.map((aMenu: MenuItem) => {
            if (aMenu === aCurrentMenu) {
                aMenu.active = !aMenu.active;
            } else {
                aMenu.active = false;
            }

            if (aMenu.submenus && aMenu.submenus.length > 0) {
                aMenu.submenus = this.toggleMenuItem(aMenu.submenus, aCurrentMenu);

                if (aMenu.submenus.find(aChild => aChild.active)) {
                    aMenu.active = true;
                }
            }

            return aMenu;
        });
    }
}
